<script setup lang="ts">
import ChevronRightIcon from 'vue-material-design-icons/ChevronRight.vue';
import HomeIcon from 'vue-material-design-icons/Home.vue';

defineProps({
  isShow: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits<{
  (e: 'close'): void;
}>();

type Item = {
  text: string;
  items: Array<{
    text: string;
    to: string;
    external?: boolean;
    newWindow?: boolean;
  }>;
};

const items: Item[] = [
  {
    text: 'スマートフォンアプリのご紹介',
    items: [
      {
        text: 'DietPlus Pro',
        to: '/s/service_dietplus',
        newWindow: true,
      },
    ],
  },
  {
    text: 'おすすめサービス',
    items: [
      {
        text: 'ニュース',
        to: '/public/article/news',
      },
      {
        text: 'ダイエット中の疑問',
        to: '/public/article/dietqa',
      },
      {
        text: 'ダイエットレシピ',
        to: '/public/article/recipe/top',
      },
    ],
  },
];

function close() {
  emit('close');
}
</script>

<template>
  <!--
    NOTE: ページ遷移に違和感が出ないように、各リンクのexternalはtrueで固定する
    ref: https://github.com/armg/kiwi-nuxt/pull/632
  -->
  <div
    v-if="isShow"
    class="fixed w-screen h-screen bg-black/40 top-0 right-0 z-40"
    data-testid="overlay"
    @click="close"
  />

  <Transition>
    <div
      v-if="isShow"
      class="fixed w-[18rem] h-screen bg-[#f6f3f2] border-t-2 border-t-[#ad948b] top-0 left-0 z-50"
    >
      <NuxtLink
        to="/"
        :external="true"
        class="p-2 border-b border-gray-300 flex gap-1 items-center"
      >
        <span class="text-[#ad948b] relative bottom-[1px]"
          ><HomeIcon :size="16"
        /></span>
        <span class="text-gray-500">トップ</span>
      </NuxtLink>

      <div v-for="item in items" :key="item.text" class="bg-white">
        <h3
          class="px-2 py-1 font-bold text-[#f46090] border-b border-b-[#e6dedb]"
        >
          {{ item.text }}
        </h3>
        <NuxtLink
          v-for="secondaryItem in item.items"
          :key="secondaryItem.text"
          :to="secondaryItem.to"
          :external="true"
          :target="secondaryItem.newWindow ? '_blank' : undefined"
          :rel="secondaryItem.newWindow ? 'noopener' : undefined"
          class="flex items-center justify-between px-2 py-1.5 border-b border-gray-200"
        >
          {{ secondaryItem.text }}
          <ChevronRightIcon :size="24" />
        </NuxtLink>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.v-enter-active,
.v-leave-active {
  transition: transform 0.4s ease;
}

.v-enter-from,
.v-leave-to {
  transform: translateX(-100%);
}
</style>
